import React, { useCallback } from 'react';
import { PiAddressBook } from 'react-icons/pi';
import { useParams } from 'react-router-dom';
import { Input, Switch, Textarea } from 'rizzui';
import useFetch from '../../../../../hooks/useFetch';
import FormGroup from '../../../../../layout/shared/form-group';
import { ProviderService } from '../../../../../services/providers/providerService';
import { ProviderApiResponse } from '../../../../../type/entities/provider-type';
import { RETRIBUTION_TYPES } from '../../../../headquarters/components/HeadquarterForm';
import moment from 'moment';

interface ProviderInfoProps { }

const ProviderInfo: React.FC<ProviderInfoProps> = () => {

    // HOOKS
    
    const { id = '' } = useParams<{ id: string }>();
    const service = new ProviderService();

    // DATA FETCHING

    // -----------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LOS DATOS DEL PROVEEDOR POR ID
     * @EN GETS THE PROVIDER DATA BY ID
     */
    // -----------------------------------------------------------------------------------------------------
    const [data, loading] = useFetch(useCallback(async () => {
        if (!id || id === '') return null;
        const response = await service.getProvideById(id);
        return response.getResponseData() as ProviderApiResponse;
    }, [id]));
    // -----------------------------------------------------------------------------------------------------

    // RENDER

    return (
        <>
            <div className="@container">
                <div className="grid gap-7 divide-y-2 divide-dashed divide-gray-200">
                    <FormGroup
                        title="Información General"
                        description="Datos principales"
                        className='pt-4'
                        titleCols="@md:col-span-2"
                        childCols="@md:col-span-10 md:grid-cols-4"
                    >
                        <Input
                            disabled
                            label="Nombre"
                            className="col-span-4 md:col-span-2"
                            placeholder="Nombre de la empresa"
                            value={data?.companyName ?? ""}
                        />
                        <Input
                            disabled
                            label="CIF"
                            className="col-span-4 md:col-span-2"
                            value={data?.cif ?? ""}
                        />
                        <Input
                            disabled
                            label="Email"
                            className="col-span-4 md:col-span-2"
                            value={data?.email ?? ""}
                        />
                        <Input
                            disabled
                            label="Teléfono"
                            className="col-span-4 md:col-span-2"
                            value={data?.telephone ?? ""}
                        />
                        <Input
                            disabled
                            label="Tipo de retribución"
                            className="col-span-4 md:col-span-2"
                            value={RETRIBUTION_TYPES.find((item) => item.value === data?.retributionType)?.label}
                        />

                        <Input
                            disabled
                            label="Tipo de proveedor"
                            className="col-span-4 md:col-span-2"
                            value={data?.providerType?.name ?? ""}
                        />

                        <Input
                            disabled
                            label="Fecha de creación"
                            className="col-span-4 md:col-span-2"
                            value={moment(data?.createdAt?.date).format('DD/MM/YYYY')}
                        />

                        <Input
                            disabled
                            label="Fecha de actualización"
                            className="col-span-4 md:col-span-2"
                            value={data?.updatedAt ? moment(data?.updatedAt?.date).format('DD/MM/YYYY') : ''}
                        />

                        <Input
                            disabled
                            label="Código"
                            className="col-span-4 md:col-span-2"
                            value={data?.code ?? ""}
                        />

                        <Input
                            disabled
                            label="Domicilio Fiscal"
                            placeholder="Domicilio Fiscal"
                            prefix={<PiAddressBook className="h-6 w-6 text-gray-500" />}
                            value={data?.taxDomicile ?? ""}
                            className="md:col-span-2"
                        />
                        
                        <Switch
                            id="autoInvoice"
                            label={data?.autoInvoice ? 'Fact. auto. activada' : 'Fact. auto. desactivada'}
                            checked={data?.autoInvoice}
                            className='md:col-span-2 items-center'
                            switchClassName='pointer-events-none'
                        />

                        <Textarea
                            disabled
                            className='col-span-4'
                            label="Comentarios"
                            value={data?.comments ?? ""}
                        />

                    </FormGroup>

                    <FormGroup
                        title="Organización"
                        description="Datos de la organización"
                        className='pt-4'
                        titleCols="@md:col-span-2"
                        childCols="@md:col-span-10 md:grid-cols-3"
                    >
                        <Input
                            disabled
                            label="Nombre"
                            placeholder="Nombre de la organización"
                            value={data?.company?.name ?? ""}
                        />
                        <Input
                            id="companyCif"
                            disabled
                            label="CIF"
                            value={data?.company?.cif ?? ""}
                        />
                        <Input
                            prefix={<PiAddressBook className="h-6 w-6 text-gray-500" />}
                            label="Dirección"
                            placeholder="info@rochel.es"
                            value={data?.company?.address ?? ""}
                            disabled
                        />
                    </FormGroup>
                </div>
            </div>
        </>
    );
};

export default ProviderInfo;